export default {
  invoices: [],
  invoice: {},
  invoiceHelpers: {}
}



// WEBPACK FOOTER //
// ./src/components/invoice/store/state.js